import { Injectable } from '@angular/core';
import { DivisionSalesNetwork, UserStoreDivisionDto } from '../../models/division.model';
import { HttpClientService } from '../httpClient/httpclient.service';
import { Observable } from 'rxjs/Observable';
import { ListMetadata } from '../../models/list-metadata.model';
import { publishReplay, refCount } from 'rxjs/operators';
import { UsersService } from '../user/users.service';

@Injectable()
export class DivisionSalesNetworkService {

  private baseUrl = HttpClientService.BASE_MS_COMMON + '/division-sales-network';
  private cachedFields: Observable<any>;

  constructor (private h: HttpClientService,
    private svcUsers: UsersService) { }
  list_division: DivisionSalesNetwork[];
  get(id: number): Observable<DivisionSalesNetwork> {
    return this.h.get(this.baseUrl + '/' + id)
  }

  list(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<Array<DivisionSalesNetwork>> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.h.get(this.baseUrl + '/getDivisionSalesNetworkList' +
      (params.toString() ? '?' + params.toString().replace(/\+/gi, '%2B').replace(/'/gi, "''") : '' ));
  }

  getList() {
    return this.h.get(this.baseUrl + '/');
  }
  getListExpanded(): Observable<DivisionSalesNetwork[]> {
    return this.h.get(this.baseUrl + '/expanded')
  }

  listUrl= HttpClientService.BASE_MS_COMMON
  getStoreDivisionUser(id: string): Observable<UserStoreDivisionDto[]> {
    const url = `${this.listUrl}/store/store_divisions/user/${id}`;
    return this.h.get(url);
  }
  
  

  create(dsn: DivisionSalesNetwork): Observable<DivisionSalesNetwork> {
    return this.h.post(this.baseUrl + '/', dsn);
  }

  update(dsn: DivisionSalesNetwork): Observable<DivisionSalesNetwork> {
    return this.h.put(this.baseUrl + '/' + dsn.id, dsn);
  }

  delete(id: number): Observable<any> {
    return this.h.delete(this.baseUrl + '/' + id);
  }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.h.get('/koncentro-common/schema/DivisionSalesNetworkDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

  /**
   * Restituisce la lista delle Sales Network Divisions.
   * Se si aggiunge il parametro salesNetworkId, restituisce solo quelle collegate a quella Rete Vendita
   * @param salesNetworkId
   */
  getSalesNetworkDivisionList(salesNetworkId?: number) {
    return this.h.get(salesNetworkId ? `${this.baseUrl}/getDivisionSalesNetworkList?sales_network_id=${salesNetworkId}` : `${this.baseUrl}/getDivisionSalesNetworkList`).map(res => {
      return this.list_division = res;
    })
  }

  getSalesNetworkDivisionListByName(salesNetworkName?: string) {
    return this.h.get(`${this.baseUrl}/getDivisionSalesNetworkList?div_sal_user_store_division=${salesNetworkName}`).map(
      res => res.map(r => ({
        label: r.division_name + ' - ' + r.sales_network_name,
        value: r.id
      }))
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/division-sales-network/divison-sales-network.service.ts